import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

export interface IBookData {
  [key: string]: {
    [key: string]: racehorse360.IRaceCondition[];
  };
}

export interface IConditionBookProps {
  bookData: any;
  rawRaces: racehorse360.IRaceCondition[];
  isShowConditionsMatches: boolean;
}

export interface IConditionBooksSelectorProps {
  className?: string;
  selectedFacility: string;
  selectedPeriod: Periods;
  availableFacilities: IAvailableFacility[];
  currentDate: Date;
  onSelectFilterOption: (string, Periods) => void;
}

export interface IAvailableFacility {
  id: string;
  name: string;
  code: string;
  earliestRaceDate: string;
  latestRaceDate: string;
  isDefault: boolean;
}

export interface IFilterOptions {
  restriction: racehorse360.RaceConditionRestriction[];
  distance: string[];
  age: racehorse360.RaceConditionAge[];
  gender: racehorse360.RaceConditionGender[];
  condition: string[];
}

export interface ICoordinates {
  top: number;
  left: number | string;
  right: number | string;
}

export interface IExpandedState {
  restriction: boolean;
  distance: boolean;
  age: boolean;
  sex: boolean;
  condition: boolean;
}

export interface IActiveAccordionIndexData {
  genderGroup: string;
  ageGroup: string;
}

export type CustomDistance = {
  id: string;
  raceDate: string;
  distance: number;
  matchedHorses: racehorse360.IHorse[];
};

export enum Periods {
  current = "current",
  pastMonth = "pastMonth",
  past3month = "past3month",
  past6month = "past6month",
  pastYear = "pastYear"
}

export enum Distance {
  short = "short",
  long = "long"
}

export enum TabsValues {
  Index = "Index",
  Conditions = "Conditions"
}
